import { useEffect, useState } from "react";

import { getFeeDescriptionsByState, getFeeReferencesByState } from "../api";
import { isNotEmptyString } from "../utils";

export default function useFeeDescriptionsByState(stateCode, onError) {
  const [loading, setLoading] = useState(false);
  const [descriptions, setDescriptions] = useState(null);
  const [references, setReferences] = useState(null);

  useEffect(() => {
    async function fetchDescriptions() {
      try {
        const result = await getFeeDescriptionsByState(stateCode);
        setDescriptions(result);
        const feeReferences = await getFeeReferencesByState(stateCode);
        setReferences(feeReferences);
      } catch (err) {
        onError(err);
      }
      setLoading(false);
    }

    if (isNotEmptyString(stateCode)) {
      setLoading(true);
      fetchDescriptions();
    }
  }, [stateCode, onError]);

  return [descriptions, references, loading];
}
